module.exports = __webpack_public_path__ + "media/images/service/c_8-363afb4df8b625fdca10ddac9073bd6c.png";